export default __webpack_public_path__ + "static/media/element_spec_21.ee792b18.webp";